export const socialConfig = [
    {
      icon: '/img/social-media/icon-facebook@2x.png',
      action: 'https://www.facebook.com/109473638527400/posts/109488195192611/?substory_index=0&sfnsn=mo',
      alt: 'facebook',
    },
    {
      icon: '/img/social-media/icon-linkedin@2x.png',
      action: 'https://www.linkedin.com/company/modern-electronics/',
      alt: 'linkedin',
    },
    {
      icon: '/img/social-media/icon-twitter@2x.png',
      action: 'https://twitter.com/SonyWorldSA?t=O087GgrWJXQAUyBj1dPKYA&s=08',
      alt: 'twitter',
    },
    {
      icon: '/img/social-media/icon-youtube@2x.png',
      action: 'https://www.youtube.com/channel/UCP1C4pML0dGPjDqaqo_g2Lg',
      alt: 'youtube',
    },
    {
      icon: '/img/social-media/icon-instagram@2x.png',
      action: 'https://www.instagram.com/mestoresksa/',
      alt: 'instagram',
    },
  ];
  